import { Component } from '@angular/core';
import { AccessManager } from '../../components/ui/access-manager/access-manager';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  standalone: false,
})
export class AdminComponent extends BasePage {
  namespace = AccessManager.AUTH_VIEW_ADMIN;
  hasReadAccess = false;
  hasWriteAccess = false;

  allowViewGroups: boolean = false;
  allowViewBrands: boolean = false;
  allowViewRoles: boolean = false;

  constructor(access: AccessManager, uiErrorHandler: UIErrorHandler) {
    super();

    access
      .getUserAccess([
        AccessManager.AUTH_SELECT_MERCHANT_BRANDS,
        AccessManager.AUTH_SELECT_MERCHANT_GROUPS,
        AccessManager.AUTH_SELECT_ROLES,
      ])
      .then((oAccess) => {
        this.allowViewRoles = oAccess[AccessManager.AUTH_SELECT_ROLES];
        this.allowViewGroups =
          oAccess[AccessManager.AUTH_SELECT_MERCHANT_GROUPS];
        this.allowViewBrands =
          oAccess[AccessManager.AUTH_SELECT_MERCHANT_BRANDS];
      })
      .catch((e) => {
        uiErrorHandler.handleError(e);
      });
  }
}
